import { useTranslation } from 'next-i18next'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { tv } from 'tailwind-variants'

import { Language, getLocaleParts } from '@nxt-insurance/constants'
import { body2 } from '@nxt-insurance/ui-kit/core/typography'

import { EVENTS, LINKS_IDS } from '@/constants/analytics'
import { useAnalytics } from '@/context/AnalyticsContext'
import TopBar from '@ui-kit/components/Bars/TopBar'

type Props = {
  shouldShow: boolean
}

const styles = tv({
  slots: {
    container: ' w-screen',
    underlined: 'underline',
  },
})

export const TravelHealthNowAvailable = (props: Props) => {
  const { track } = useAnalytics()
  const { t } = useTranslation()
  const { container, underlined } = styles()
  const { locale } = useRouter()
  const [lang, _] = getLocaleParts(locale)

  return props.shouldShow ? (
    <div className={container()}>
      <Link
        href={
          lang === Language.En
            ? 'https://product.hellogetsafe.com/travel-health'
            : 'https://product.hellogetsafe.com/de/travel-health'
        }
        onClick={() => {
          track(EVENTS.LinkClicked, {
            buttonId: LINKS_IDS.TRAVEL_HEALTH_WAITING_LIST,
          })
        }}
      >
        <TopBar
          bgColor="brandLime"
          content={
            <>
              <span className={body2()}>{t('travelHealthAvailable.title')}</span>{' '}
              <span className={body2({ className: underlined() })}>
                {t('travelHealthAvailable.underlined')}
              </span>
            </>
          }
        />
      </Link>
    </div>
  ) : null
}
